import { siteContentEn } from "@/i18n/en";
import { siteContentEs } from "@/i18n/es";
import { createSiteConfig } from "@/lib/site-config";

export const siteConfig = createSiteConfig({
  shared: {
    defaultOgImage: "/og/default.png",
    locales: ["en", "es"],
    organization: {
      legalName: "Ian Gabriel Ramos Villafañe",
      logo: "/og/default.png",
      url: "https://ianramosportfolio.pages.dev",
    },
    theme: {
      accent: "141 73% 48%",
      background: "0 0% 7%",
      foreground: "0 0% 100%",
      heroGlow: "141 73% 48%",
      primary: "141 73% 48%",
      radius: "0.5rem",
      secondary: "0 0% 12%",
      surface: "0 0% 9%",
      surfaceMuted: "0 0% 10%",
      surfaceStrong: "0 0% 12%",
    },
  },
  locales: {
    en: siteContentEn,
    es: siteContentEs,
  },
});
